import { render, staticRenderFns } from "./PurchaseOrderOtherPurchases.vue?vue&type=template&id=740b9857&scoped=true"
import script from "./PurchaseOrderOtherPurchases.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderOtherPurchases.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderOtherPurchases.vue?vue&type=style&index=0&id=740b9857&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740b9857",
  null
  
)

export default component.exports